export default __webpack_public_path__ + "static/Rectangle4387-be611fe48708b3679b6487da46ba2e77.png";